// utils/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyAUwCT-bPYst3_fusQA4zZcfYCZol4K_tE",
    authDomain: "indian-red-cross-center.firebaseapp.com",
    databaseURL: "https://indian-red-cross-center.firebaseio.com",
    projectId: "indian-red-cross-center",
    storageBucket: "indian-red-cross-center.appspot.com",
    messagingSenderId: "552686217972",
    appId: "1:552686217972:web:a4959bf9b2e85ab491cca1",
    measurementId: "G-BZ0MR6338N"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const database = getFirestore(app);
const storage = getStorage(app);

export { auth, provider, database, storage };
